import TOKEN from './TOKEN';
import * as tokenizers from './tokenizers';

function* tokenize(source, { users = [] } = {}) {
  const matches = Object.values(tokenizers)
    .flatMap((create) =>
      Array.from(source.matchAll(create.regex))
        .map((match) => create({ source, users })(match))
        .filter(Boolean)
    )
    .reduce((o, t) => ({ ...o, [t.index]: t }), {});

  let buffer;
  let index = 0;
  while (index < source.length) {
    const match = matches[index];
    if (match) {
      if (buffer) {
        yield buffer;
        buffer = undefined;
      }

      yield match;
      index += match.text.length;
    } else {
      buffer ??= { type: TOKEN.TEXT, index, text: '' };
      buffer.text += source[index];
      index += 1;
    }
  }

  if (buffer) {
    yield buffer;
    buffer = undefined;
  }

  yield { type: TOKEN.EOF, index: source.length, text: '' };
}

// A generator returns an iterator with just a next method. You must ask the next object if it is done.
// Gets around having to ask if the result is done, instead of asking the iterator if it is done.
export default (source, config) => {
  const tokens = tokenize(source, config);
  const next = () => {
    const result = tokens.next();
    return !result.done ? result.value : undefined;
  };
  return { source, config, next };
};
